import React, { useState } from 'react';
import styles from './style.module.scss';
import Button from '../../../../../../../components/new-button';
import Avatar from '../../../../../../../components/Avatar/Avatar';
import FileIcon from '../../../../../../../assets/svg/icons/common/FileIcon';
import ShowDocsModal from '../../../../../../../../components/modals/show-docs-modal/show-docs-modal';

const NoteBadge = ({ type }) => {
  const badgeType = type?.toLowerCase() || 'agent';
  return (
    <span className={`${styles.badge} ${styles[badgeType]}`}>
      {type}
    </span>
  );
};

const Note = ({ note, isReply = false, showReplyButton = true, onReplyClick }) => {
  // State for file preview and display
  const [showFiles, setShowFiles] = useState(note?.files?.length > 0);
  const [docModalFile, setDocModalFile] = useState(null);
  const [showDocsModal, setShowDocsModal] = useState(false);
  
  // Format date - "12 Oct | 10:12 PM"
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
    
    return `${day} ${month} | ${hours}:${minutes} ${ampm}`;
  };

  const handleReplyClick = () => {
    if (onReplyClick) {
      onReplyClick();
    }
  };
  
  const openFilePreview = (file) => {
    const fileType = file.file_name.split(".")[file.file_name.split(".").length - 1];
    const filePath = file.file_path.replaceAll("/", "*");
    setDocModalFile({ type: fileType, title: file.file_name, id: filePath });
    setShowDocsModal(true);
  };

  return (
    <div className={`${styles.note} ${isReply ? styles.reply : ''}`}>
      <div className={styles.avatar}>
        <Avatar name={note?.who?.charAt(0) ?? "M"} />
      </div>

      <div className={styles.content}>
        <div className={styles.noteHeader}>
          <div className={styles.userInfo}>
            <h5 className={styles.noteHeaderTitle}>{note?.who}</h5>
            {note?.recipient && <span className={styles.recipientText}>to</span>}
            {note?.type && <NoteBadge type={note?.type} />}
          </div>
          <span className={styles.noteHeaderTimestamp}>
            {formatDate(note?.created_at) || note?.created_ago}
          </span>
        </div>

        <div className={styles.noteBody}>
          {note?.content}
        </div>
        
        {note?.files && note.files.length > 0 && showFiles && (
          <div className={styles.attachments}>
            {note.files.map((file, index) => {
              const fileExt = file.file_name?.split('.').pop().toLowerCase() || '';
              const isImage = /^(jpg|jpeg|png|gif|webp)$/i.test(fileExt);
              const isPdf = fileExt === 'pdf';
              const isDoc = /^(doc|docx)$/i.test(fileExt);
              const isExcel = /^(xls|xlsx)$/i.test(fileExt);
              
              let iconColor = "#E03B24"; // default
              if (isPdf) iconColor = "#E03B24"; // red for PDFs
              if (isDoc) iconColor = "#4C70EF"; // blue for Word docs
              if (isExcel) iconColor = "#34A853"; // green for Excel
              
              return (
                <div 
                  key={index} 
                  className={styles.attachment}
                  onClick={() => openFilePreview(file)}
                >
                  <FileIcon color={iconColor} />
                  <span className={styles.fileName}>{file.file_name}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {showDocsModal && (
        <ShowDocsModal
          isOpen={showDocsModal}
          close={() => setShowDocsModal(false)}
          file={docModalFile}
          variant="v2"
        />
      )}

      {showReplyButton && !isReply && (
        <div className={styles.button}>
          <Button
            variant="ghost"
            size="small"
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M14.5004 3.5C14.4986 5.22335 13.8132 6.87559 12.5946 8.09418C11.376 9.31278 9.72374 9.99818 8.00039 10H3.20727L5.35414 12.1462C5.44796 12.2401 5.50067 12.3673 5.50067 12.5C5.50067 12.6327 5.44796 12.7599 5.35414 12.8538C5.26032 12.9476 5.13308 13.0003 5.00039 13.0003C4.86771 13.0003 4.74046 12.9476 4.64664 12.8538L1.64664 9.85375C1.60016 9.80731 1.56328 9.75217 1.53811 9.69147C1.51295 9.63077 1.5 9.56571 1.5 9.5C1.5 9.43429 1.51295 9.36923 1.53811 9.30853C1.56328 9.24783 1.60016 9.19269 1.64664 9.14625L4.64664 6.14625C4.74046 6.05243 4.86771 5.99972 5.00039 5.99972C5.13308 5.99972 5.26032 6.05243 5.35414 6.14625C5.44796 6.24007 5.50067 6.36732 5.50067 6.5C5.50067 6.63268 5.44796 6.75993 5.35414 6.85375L3.20727 9H8.00039C9.45858 8.99835 10.8566 8.41835 11.8877 7.38726C12.9187 6.35617 13.4987 4.95818 13.5004 3.5C13.5004 3.36739 13.5531 3.24021 13.6468 3.14645C13.7406 3.05268 13.8678 3 14.0004 3C14.133 3 14.2602 3.05268 14.3539 3.14645C14.4477 3.24021 14.5004 3.36739 14.5004 3.5Z" fill="#3A383F" />
              </svg>
            }
            onClick={handleReplyClick}
            type="button"
          />
        </div>
      )}
    </div>
  );
};

export default Note;